import React from 'react';
import { formatMonthLabel } from '../../../../Helpers/invoiceAutomationMonthHelper';
import { formatCount, getPreviewDraftNote } from '../../../../Helpers/invoiceAutomationRunHelper';

// The drafts Run Now would make or add to, one row each, oldest month first: the draft's name, whether it is new or
// which open draft the jobs go on, and how many jobs it gets. Says so when there is nothing to add.
export default function InvoiceAutomationRunDrafts({ drafts = [] }) {
  if (drafts.length === 0) {
    return <div className='iauto-run-nothing'>There are no ready jobs to add.</div>;
  }

  return (
    <div className='iauto-run-drafts'>
      {drafts.map((draft) => (
        <div
          key={draft.jobMonth}
          className='iauto-run-draft'
        >
          <div>
            <span className='iauto-run-draft-name'>{draft.invoiceName || formatMonthLabel(draft.jobMonth)}</span>
            <span className='iauto-run-draft-note'>{getPreviewDraftNote(draft)}</span>
          </div>
          <span className='iauto-run-draft-jobs'>{formatCount(draft.jobsToAdd, 'job', 'jobs')}</span>
        </div>
      ))}
    </div>
  );
}
